<template>
  <!-- <NuxtPage /> -->
  <NuxtLoadingIndicator />
  <NuxtLayout>
    <NuxtPage />

    <!-- Toast service -->
    <Toast v-if="!isMobile" position="bottom-right" />
    <Toast v-if="isMobile" position="top-center" />
    <ConfirmDialog
      class="min-w-[25em] max-w-[32em]"
      :pt="{
        content: 'text-sm text-muted px-8',
      }"
    ></ConfirmDialog>
  </NuxtLayout>
</template>

<script setup>
import { useBreakpoints } from "@vueuse/core";

const breakpoints = useBreakpoints(BREAKPOINTS);
const isMobile = breakpoints.smaller("laptop");
</script>
